// MYMY FUNNEL PAGES' CONSTANTS, SETTINGS, & HELPERS
import {
   MENUS_PRODUCT_TYPE,
   DISHES_PRODUCT_TYPE,
   DRINKS_PRODUCT_TYPE,
   ACCESSORIES_PRODUCT_TYPE,
   SHIPPING_ADJUSTER_TYPE,
   DISCOUNT_ADJUSTER_TYPE,
   TAX_ADJUSTER_TYPE,
} from '@/js/funnel/_config/commerce.js';


// CART SCENARIOS
// =================================================================================================

// NOTE!! these must match the scenarios set in ./cms/modules/mymy/src/routes/FunnelRoutes.php
/** @type {string} **/
export const SCENARIO_MENUS_LISTING_PAGE = 'menusListing';
/** @type {string} **/
export const SCENARIO_SELECTION_PAGE = 'selection';
/** @type {string} **/
export const SCENARIO_DELIVERY_PAGE = 'delivery';
/** @type {string} **/
export const SCENARIO_OVERVIEW_PAGE = 'overview';
/** @type {string} **/
export const SCENARIO_CONFIRMATION_PAGE = 'confirmation';

/**
 * Is the customer on the funnel Selection page?
 *
 * @return {boolean}
 */
export const isSelectionPage = () => {
   try {
      return window.mymy.request.scenario === SCENARIO_SELECTION_PAGE;
   }
   catch (e) {
      if(window.Sentry) {
         Sentry.captureException(e);
      }
      console.error(e);
      return false;
   }
};

/**
 * Is the customer on the funnel Delivery page?
 *
 * @return {boolean}
 */
export const isDeliveryPage = () => {
   try {
      return window.mymy.request.scenario === SCENARIO_DELIVERY_PAGE;
   }
   catch (e) {
      if(window.Sentry) {
         Sentry.captureException(e);
      }
      console.error(e);
      return false;
   }
};

/**
 * Is the customer on the funnel Overview page?
 *
 * @return {boolean}
 */
export const isOverviewPage = () => {
   try {
      return window.mymy.request.scenario === SCENARIO_OVERVIEW_PAGE;
   }
   catch (e) {
      if(window.Sentry) {
         Sentry.captureException(e);
      }
      console.error(e);
      return false;
   }
};

/**
 * Is the customer on the funnel Confirmation page?
 *
 * @return {boolean}
 */
export const isConfirmationPage = () => {
   try {
      return window.mymy.request.scenario === SCENARIO_CONFIRMATION_PAGE;
   }
   catch (e) {
      if(window.Sentry) {
         Sentry.captureException(e);
      }
      console.error(e);
      return false;
   }
};


// ORDER SUMMARY
// ===============================================================================================

/**
 * Get a standardized JS object of data to store in the Vuex `summary` store object, which its
 * child components can read and understand.
 *
 * `item` could be an object from Commerce's response when requesting the cart or a
 * MenuItemControls.vue component (only applies to dishes, drinks, and accessories).
 *
 * @param type {string}
 * @param item {object}
 * @return {{quantity: number, lineItemId: null, price: {gross: number, net: number}, id: null, title: string, type: string, slug: string}}
 */
export const getSummaryItemObject = (type, item) => {
   let object = {
      id: null,
      lineItemId: null,
      price: {gross: 0, net: 0},
      quantity: 0,
      sectionIndex: null,
      slug: '',
      title: '',
      type: '',
   };

   try {
      switch (type) {
         case MENUS_PRODUCT_TYPE:
            object.brand = item.brand;
            object.lineItemId = item.lineItemId;
            object.price.gross = item.price.gross;
            object.price.net = item.price.net;
            object.quantity = item.quantity;
            object.sectionIndex = item.sectionIndex;
            object.sku = item.sku;
            object.slug = item.slug;
            object.title = item.title;
            object.type = item.type;
            object.variantId = item.variantId;
            object.taxRates = item.taxRates;
            break;
         case DISHES_PRODUCT_TYPE:
         case DRINKS_PRODUCT_TYPE:
         case ACCESSORIES_PRODUCT_TYPE:
            object.brand = item.product.brand;
            object.id = item.id;
            object.lineItemId = item.lineItemId;
            object.price.gross = item.price.gross;
            object.price.net = item.price.net;
            object.quantity = item.quantity;
            object.sectionIndex = item.sectionIndex;
            object.sku = item.variant.sku;
            object.slug = item.variant.slug;
            object.title = item.variant.title;
            object.type = item.product.type;
            object.variantId = item.variant.id;
            object.taxRates = item.taxRates;
            break;
         case SHIPPING_ADJUSTER_TYPE:
         case DISCOUNT_ADJUSTER_TYPE:
            let title = item.sourceSnapshot ? item.sourceSnapshot.description : item.description;
            object.id = item.id ?? null;
            object.infoText = item.infoText ?? '';
            object.lineItemId = item.lineItemId ?? null;
            object.price.gross = Math.round(item.amount * 100);
            object.price.net = Math.round(item.amount * 100);
            object.quantity = 1;
            object.slug = item.slug ?? slugify(title);
            object.title = title;
            object.type = item.type;
            break;
         case TAX_ADJUSTER_TYPE:
            object.id = item.id ?? null;
            object.infoText = '';
            object.lineItemId = item.lineItemId ?? null;
            object.price.gross = Math.round(item.amount * 100);
            object.price.net = Math.round(item.amount * 100);
            object.quantity = 1;
            object.slug = slugify(item.description);
            object.title = item.description;
            object.type = item.type;
            break;
      }
   }
   catch (e) {
      if(window.Sentry) {
         Sentry.captureException(e);
      }
      console.error(e);
   }

   return object;
};

const slugify = (str) => {
   const lcStr = str.toLowerCase()
   return lcStr.replace(/ /g, '-')
}


// DELIVERY PAGE
// ===============================================================================================

/**
 * The value for a new billing address the customer is providing. Otherwise, the delivery
 * address will be used for billing.
 *
 * NOTE: this must match the constant in this file:
 * ./cms/modules/mymy/src/models/forms/funnel/DeliveryFormModel.php
 *
 * @type {string}
 */
export const NEW_BILLING_ADDRESS_KEY = 'new';